import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { TranslateService } from '@ngx-translate/core';
import { Permission } from 'src/app/common/enums';
import { AuthService } from 'src/app/core/authentication/auth.service';

export enum EFoldersListType {
  EFolders = 1,
  EDocuments = 2,
}

@Component({
  selector: 'app-e-folders',
  templateUrl: './e-folders.component.html',
  styleUrls: ['./e-folders.component.scss'],
  standalone: false
})
export class EFoldersComponent implements OnInit, AfterViewInit {
  @ViewChild("tab", { static: true }) tab: MatTabGroup;
  listType: EFoldersListType = this.getInitialListType();
  listTypes = EFoldersListType;

  constructor(
    private translate: TranslateService,
    private authService: AuthService
  ) { }
  ngAfterViewInit(): void {
    setTimeout(() => this.tab.selectedIndex = this.listType == EFoldersListType.EFolders ? 0 : 1);

  }

  ngOnInit(): void {

  }

  onTabChanged(event: MatTabChangeEvent): void {
    const map = new Map<string, EFoldersListType>([
      [this.translate.instant('EFolders.FoldersList'), EFoldersListType.EFolders],
      [this.translate.instant('EFolders.DocumentsList'), EFoldersListType.EDocuments]
    ]);

    if (!map.has(event.tab.textLabel)) {
      return;
    }

    const index = map.get(event.tab.textLabel);

    this.listType = index;
  }

  private getInitialListType() {
    return this.authService.hasAnyPermission([Permission.ViewWorkerAgreementsList]) ? EFoldersListType.EFolders : EFoldersListType.EDocuments;
  }
}
